import React from 'react';
import { getDate, getTime } from '../history.service';
import { activityTypes } from '../../../../helper/constants.helper';

const ActivityDetails = ({ historyItem }) => {
  return (
    <>
      <p className="semi-bold">
        {historyItem.type === activityTypes.SELF_ASSESSMENT
          ? 'Self-Assessment'
          : historyItem.type === activityTypes.COURSE
            ? 'Short Course'
            : historyItem.type === activityTypes.MEETING
              ? 'Booking'
              : historyItem.type === activityTypes.HELPLINE
                ? 'Helpline call'
                : null}
      </p>
      {historyItem.type === activityTypes.MEETING && (
        <>
          <p>
            {getDate(historyItem.meetingStart)} at {getTime(historyItem.meetingStart)} -{' '}
            {getTime(historyItem.meetingEnd)}
          </p>
          <p className="semi-bold">{historyItem.serviceName}</p>
        </>
      )}
      {historyItem.type === activityTypes.HELPLINE && (
        <p>
          {historyItem.end_time
            ? `${getTime(historyItem.start_time, true)}- ${getTime(historyItem.end_time, true)}`
            : null}
        </p>
      )}
      <p className="semi-bold">{historyItem.name}</p>

      <p className="semi-bold">{historyItem.activityName}</p>
      <style jsx>
        {`
          .semi-bold {
            font-weight: 500;
          }
        `}
      </style>
    </>
  );
};

export default ActivityDetails;
